module.exports = __webpack_public_path__ + "img/foherb_logo.afb97f35.png";